<template>
  <div>
    <div class="app-container">
      <!-- WEB VIEW -->
      <div class="banner m-prof-banner position-relative">
        <div v-if="isBackgroundImageLoading" class="d-flex align-items-center flex-column justify-content-center mt-4">
          <div :style="{ height: '400px' }">
            <div class="spinner-border spinner-class"></div>
          </div>
        </div>
        <!-- <img v-show="!isBackgroundImageLoading" :src="authUser.user.bg_img != null ? authUser.user.bg_img[0].url : '../../../assets/images/defaultBackImg.jpg'" alt="" @load="onLoadHandler" /> -->
        <img v-else-if="authUser.user.bg_img" :src="authUser.user.bg_img[0].url" alt="bg-image" @load="onLoadHandler" />
        <img v-else src="https://mycircle-prod.s3.amazonaws.com/default-profile-bg-img1698993539.jpg" alt="background" class="default-profile-bg-img" />
        <!-- <img v-show="!isBackgroundImageLoading && authUser.user.bg_img" :src="authUser.user.bg_img[0].url" alt="bg-image" @load="onLoadHandler" /> -->
        <div class="camera-icon-button profile-bg h-100" :style="{ right: '132px', top: '0px' }">
          <button class="threedot-menu-edited-mob-doc" @click="() => (displaypicDots = !displaypicDots)">
            <div class="dot-menu-cont">
              <div class="camera-icon-btn">
                <label class="camera-bttn cp d-flex justify-content-center align-items-center" aria-hidden="true" :style="{ background: getPrimaryColor() }">
                  <font-awesome-icon size="2x" :style="{ color: 'white !important', transform: 'scale(0.5)', height: '100%' }" :icon="['fas', 'camera']" />
                </label>
              </div>
            </div>

            <div :class="`${displaypicDots ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`" :style="{ 'min-width': '200px', top: '50px' }">
              <p class="card-item" @click="() => $refs.bgImageGalleryModal.show(backgroundImages)">
                <font-awesome-icon size="1x" :icon="['fal', 'images']" class="mr-2" />
                Select image
              </p>
              <p class="card-item position-relative">
                <font-awesome-icon size="1x" :icon="['fal', 'arrow-from-bottom']" class="mr-2" />
                <input
                  title=""
                  class="camera-icon-inp position-absolute h-100 w-100"
                  type="file"
                  accept="image/png, image/jpeg, image/gif, image/svg+xml"
                  ref="Wbg"
                  @change="handleWBackgroundPicUpload()"
                  :style="{ left: '0', opacity: '0' }"
                />
                Upload image
              </p>
              <p class="divider"></p>
              <p :class="`card-item ${authUser.user.bg_img ? '' : 'disabled-remove-bg-btn'}`" @click="removebgImage()">
                <font-awesome-icon size="1x" :icon="['fal', 'trash']" class="mr-2" />
                Remove
              </p>
            </div>
          </button>
        </div>
      </div>
      <div class="profile-subnav">
        <div class="dovemed-wrapper w-100">
          <!-- deleted left panel -->
          <div class="d-flex phy-profile-card-container">
            <button class="threedot-menu" :style="{ background: '#fff', border: 'none', display: 'flex', 'align-self': 'flex-end' }" @click="showOptions">
              <font-awesome-icon size="1x" :style="{ color: '#94A3B8' }" :icon="['fas', 'ellipsis-v']" />

              <div
                v-if="displayDots"
                :style="{ display: 'flex', 'flex-direction': 'column', 'align-self': 'flex-end', gap: '12px', 'z-index': '1' }"
                :class="`${displayDots ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`"
              >
                <p class="card-item d-flex flex-row" :style="{ 'font-weight': '500', color: 'black' }" @click="() => $refs.ShareProfileModal.showModal()">
                  <svg width="20" height="20" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                    <path
                      d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
                      fill="black"
                    /></svg
                  >Share Profile
                </p>
              </div>
            </button>
            <div class="profile-image mr-3 position-relative">
              <a-avatar
                :style="{ color: ' #ffffff !important', 'background-color': authUser.user.url ? authUser.user.url : '' || authUser.user.picture ? authUser.user.picture : '' ? '' : '#C997C5' }"
                :size="150"
                :src="authUser.user.url || authUser.user.picture"
                class="text-capitalize"
              >
                {{ authUser.user.display_name[0] }}
              </a-avatar>
            </div>
            <div class="d-flex flex-row" v-if="authUser.user.is_verified" :style="{ 'margin-top': '26px' }">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :style="{ 'margin-right': '8px' }">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.6458 0.648784C10.9757 0.238571 11.4736 0 11.9998 0C12.526 0 13.0239 0.238571 13.3537 0.648784L14.9657 2.65518C15.3367 3.11777 15.9179 3.35907 16.5072 3.29518L19.0659 3.01678C19.5905 2.95846 20.1132 3.14192 20.4865 3.51539C20.8598 3.88886 21.0431 4.41184 20.9848 4.93677L20.7066 7.49676C20.6427 8.08643 20.8839 8.66795 21.3462 9.03916L23.3516 10.652C23.7616 10.982 24 11.4801 24 12.0066C24 12.5331 23.7616 13.0312 23.3516 13.3613L21.3398 14.9666C20.8776 15.3384 20.6366 15.9201 20.7002 16.5101L20.9784 19.0701C21.0371 19.5951 20.8539 20.1183 20.4805 20.4919C20.1072 20.8655 19.5842 21.0488 19.0595 20.9901L16.5008 20.7117C15.9115 20.6476 15.3301 20.8889 14.9593 21.3517L13.3537 23.3506C13.0241 23.7612 12.5261 24 11.9998 24C11.4734 24 10.9755 23.7612 10.6458 23.3506L9.03497 21.3453C8.66351 20.8826 8.08199 20.6414 7.49234 20.7053L4.93371 20.9837C4.40886 21.0428 3.88565 20.8596 3.51218 20.4859C3.1387 20.1123 2.95562 19.5888 3.01474 19.0637L3.29299 16.5037C3.35682 15.9137 3.11569 15.3319 2.65333 14.9602L0.649074 13.3485C0.238717 13.0187 0 12.5205 0 11.9938C0 11.4672 0.238717 10.969 0.649074 10.6392L2.65333 9.02636C3.11584 8.65528 3.35705 8.07366 3.29299 7.48396L3.01474 4.92397C2.95604 4.39894 3.13926 3.8757 3.51263 3.50214C3.886 3.12857 4.40896 2.94524 4.93371 3.00398L7.49234 3.28238C8.08196 3.34604 8.66338 3.10482 9.03497 2.64238L10.6458 0.648784Z"
                  fill="#00C853"
                />
                <path
                  d="M16.5 9L12.0214 15.3893C11.8746 15.5985 11.6502 15.7293 11.4063 15.7477C11.1624 15.7662 10.923 15.6706 10.7501 15.4856L8.0625 12.6112"
                  stroke="white"
                  stroke-width="2.08333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <p :style="{ 'font-weight': '700', 'font-size': '16px', 'line-height': '24px', color: '#00C853' }">Verified & Claimed</p>
            </div>

            <div class="doc-info">
              <p class="m-0 doc-name text-capitalize" v-if="authUser.user">
                {{ authUser.user.display_name }}
                <!-- {{ userValues.user_info.title ? "," + userValues.user_info.title : "" }} -->
              </p>
              <div class="tag-cont">
                <div class="physician-tag">
                  <font-awesome-icon v-if="authUser.user.role === 'hcp'" class="tag-icon-oran" :icon="['far', 'user-nurse']" :style="{ fill: '#F5A623' }" />
                  <font-awesome-icon v-if="authUser.user.role === 'nfp_administrator'" class="tag-icon-oran" :icon="['far', 'hand-holding-heart']" :style="{ fill: '#F5A623' }" />
                  <svg v-if="authUser.user.role === 'doctor'" :style="{ fill: '#F5A623' }" class="tag-icon-oran" width="10" height="12" viewBox="0 0 10 12" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M3.0835 3.11198C3.0835 1.51693 4.38232 0.195312 6.00016 0.195312C7.59521 0.195312 8.91683 1.51693 8.91683 3.11198C8.91683 4.72982 7.59521 6.02865 6.00016 6.02865C4.38232 6.02865 3.0835 4.72982 3.0835 3.11198ZM7.82308 3.11198C7.82308 2.10938 7.00277 1.28906 6.00016 1.28906C4.97477 1.28906 4.17725 2.10938 4.17725 3.11198C4.17725 4.13737 4.97477 4.9349 6.00016 4.9349C7.00277 4.9349 7.82308 4.13737 7.82308 3.11198ZM4.54183 9.37826C5.06592 9.53776 5.45329 10.0163 5.45329 10.5859C5.45329 11.2923 4.86084 11.862 4.17725 11.862C3.47087 11.862 2.9012 11.2923 2.9012 10.5859C2.9012 10.0163 3.26579 9.53776 3.81266 9.37826V8.44401C2.7417 8.87695 1.98975 9.92513 1.98975 11.1328V11.3151C1.98975 11.6341 1.7391 11.862 1.44287 11.862C1.12386 11.862 0.895996 11.6341 0.895996 11.3151V11.1328C0.895996 8.92253 2.67334 7.1224 4.90641 7.1224H7.09391C9.3042 7.1224 11.1043 8.92253 11.1043 11.1328V11.3151C11.1043 11.6341 10.8537 11.862 10.5575 11.862C10.2384 11.862 10.0106 11.6341 10.0106 11.3151V11.1328C10.0106 9.92513 9.23584 8.87695 8.18766 8.44401V9.37826C8.71175 9.53776 9.09912 10.0163 9.09912 10.5859V11.3151C9.09912 11.5202 8.91683 11.6797 8.73454 11.6797C8.52946 11.6797 8.36995 11.5202 8.36995 11.3151V10.5859C8.36995 10.2897 8.1193 10.0391 7.82308 10.0391C7.50407 10.0391 7.2762 10.2897 7.2762 10.5859V11.3151C7.2762 11.5202 7.09391 11.6797 6.91162 11.6797C6.70654 11.6797 6.54704 11.5202 6.54704 11.3151V10.5859C6.54704 10.0163 6.91162 9.53776 7.4585 9.37826V8.23893C7.32178 8.23893 7.20784 8.21615 7.09391 8.21615H4.90641C4.76969 8.21615 4.65576 8.23893 4.54183 8.23893V9.37826ZM4.17725 11.1328C4.47347 11.1328 4.72412 10.9049 4.72412 10.5859C4.72412 10.2897 4.47347 10.0391 4.17725 10.0391C3.85824 10.0391 3.63037 10.2897 3.63037 10.5859C3.63037 10.9049 3.85824 11.1328 4.17725 11.1328Z"
                    />
                  </svg>
                  <svg
                    v-if="authUser.user.role === 'hospital_administrator'"
                    :style="{ fill: '#F5A623' }"
                    class="tag-icon-oran"
                    width="14"
                    height="12"
                    viewBox="0 0 14 12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.53906 9.67448H3.6276C3.4681 9.67448 3.35417 9.8112 3.35417 9.94792V10.8594C3.35417 11.0189 3.4681 11.1328 3.6276 11.1328H4.53906C4.67578 11.1328 4.8125 11.0189 4.8125 10.8594V9.94792C4.8125 9.8112 4.67578 9.67448 4.53906 9.67448ZM7.45573 9.67448H6.54427C6.38477 9.67448 6.27083 9.8112 6.27083 9.94792V10.8594C6.27083 11.0189 6.38477 11.1328 6.54427 11.1328H7.45573C7.59245 11.1328 7.72917 11.0189 7.72917 10.8594V9.94792C7.72917 9.8112 7.59245 9.67448 7.45573 9.67448ZM4.53906 7.48698H3.6276C3.4681 7.48698 3.35417 7.6237 3.35417 7.76042V8.67188C3.35417 8.83138 3.4681 8.94531 3.6276 8.94531H4.53906C4.67578 8.94531 4.8125 8.83138 4.8125 8.67188V7.76042C4.8125 7.6237 4.67578 7.48698 4.53906 7.48698ZM7.45573 7.48698H6.54427C6.38477 7.48698 6.27083 7.6237 6.27083 7.76042V8.67188C6.27083 8.83138 6.38477 8.94531 6.54427 8.94531H7.45573C7.59245 8.94531 7.72917 8.83138 7.72917 8.67188V7.76042C7.72917 7.6237 7.59245 7.48698 7.45573 7.48698ZM10.3724 7.48698H9.46094C9.30143 7.48698 9.1875 7.6237 9.1875 7.76042V8.67188C9.1875 8.83138 9.30143 8.94531 9.46094 8.94531H10.3724C10.5091 8.94531 10.6458 8.83138 10.6458 8.67188V7.76042C10.6458 7.6237 10.5091 7.48698 10.3724 7.48698ZM12.1042 2.38281H11.375V1.67643C11.375 0.85612 10.7142 0.195312 9.91667 0.195312H4.06055C3.26302 0.195312 2.60221 0.85612 2.60221 1.67643V2.38281H1.89583C1.07552 2.38281 0.4375 3.04362 0.4375 3.84115V11.3151C0.4375 11.6341 0.665365 11.862 0.984375 11.862C1.2806 11.862 1.53125 11.6341 1.53125 11.3151V3.84115C1.53125 3.65885 1.69076 3.47656 1.89583 3.47656H3.69596V1.67643C3.69596 1.47135 3.85547 1.28906 4.06055 1.28906H9.91667C10.1217 1.28906 10.2812 1.47135 10.2812 1.67643V3.47656H12.1042C12.2865 3.47656 12.4688 3.65885 12.4688 3.84115V11.3151C12.4688 11.6341 12.6966 11.862 13.0156 11.862C13.3118 11.862 13.5625 11.6341 13.5625 11.3151V3.84115C13.5625 3.04362 12.9017 2.38281 12.1042 2.38281ZM10.3724 9.67448H9.46094C9.30143 9.67448 9.1875 9.8112 9.1875 9.94792V10.8594C9.1875 11.0189 9.30143 11.1328 9.46094 11.1328H10.3724C10.5091 11.1328 10.6458 11.0189 10.6458 10.8594V9.94792C10.6458 9.8112 10.5091 9.67448 10.3724 9.67448ZM8.57227 3.47656H7.72917V2.63346C7.72917 2.49674 7.61523 2.38281 7.47852 2.38281H6.4987C6.36198 2.38281 6.27083 2.49674 6.27083 2.63346V3.47656H5.40495C5.26823 3.47656 5.17708 3.5905 5.17708 3.72721V4.70703C5.17708 4.84375 5.26823 4.9349 5.40495 4.9349H6.27083V5.80078C6.27083 5.9375 6.36198 6.02865 6.4987 6.02865H7.47852C7.61523 6.02865 7.72917 5.9375 7.72917 5.80078V4.9349H8.57227C8.70898 4.9349 8.82292 4.84375 8.82292 4.70703V3.72721C8.82292 3.5905 8.70898 3.47656 8.57227 3.47656Z"
                    />
                  </svg>
                  <svg
                    v-if="authUser.user.role === 'clinic_administrator'"
                    :style="{ fill: '#F5A623' }"
                    class="tag-icon-oran"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.45833 4.2513V3.45378C6.45833 3.36263 6.36719 3.27148 6.25325 3.27148H5.56966V2.58789C5.56966 2.47396 5.47852 2.38281 5.38737 2.38281H4.58984C4.4987 2.38281 4.40755 2.47396 4.40755 2.58789V3.27148H3.72396C3.61003 3.27148 3.54167 3.36263 3.54167 3.45378V4.2513C3.54167 4.34245 3.61003 4.43359 3.72396 4.43359H4.40755V5.11719C4.40755 5.23112 4.4987 5.29948 4.58984 5.29948H5.38737C5.47852 5.29948 5.56966 5.23112 5.56966 5.11719V4.43359H6.25325C6.36719 4.43359 6.45833 4.34245 6.45833 4.2513ZM3.9974 6.75781H3.08594C2.92643 6.75781 2.8125 6.89453 2.8125 7.03125V7.94271C2.8125 8.10221 2.92643 8.21615 3.08594 8.21615H3.9974C4.13411 8.21615 4.27083 8.10221 4.27083 7.94271V7.03125C4.27083 6.89453 4.13411 6.75781 3.9974 6.75781ZM3.9974 8.94531H3.08594C2.92643 8.94531 2.8125 9.08203 2.8125 9.21875V10.1302C2.8125 10.2897 2.92643 10.4036 3.08594 10.4036H3.9974C4.13411 10.4036 4.27083 10.2897 4.27083 10.1302V9.21875C4.27083 9.08203 4.13411 8.94531 3.9974 8.94531ZM7.91667 0.195312H2.08333C1.26302 0.195312 0.625 0.85612 0.625 1.65365V11.3151C0.625 11.6341 0.852865 11.862 1.17188 11.862C1.4681 11.862 1.71875 11.6341 1.71875 11.3151V1.65365C1.71875 1.47135 1.87826 1.28906 2.08333 1.28906H7.91667C8.09896 1.28906 8.28125 1.47135 8.28125 1.65365V11.3151C8.28125 11.6341 8.50911 11.862 8.82812 11.862C9.12435 11.862 9.375 11.6341 9.375 11.3151V1.65365C9.375 0.85612 8.71419 0.195312 7.91667 0.195312ZM6.91406 6.75781H6.0026C5.8431 6.75781 5.72917 6.89453 5.72917 7.03125V7.94271C5.72917 8.10221 5.8431 8.21615 6.0026 8.21615H6.91406C7.05078 8.21615 7.1875 8.10221 7.1875 7.94271V7.03125C7.1875 6.89453 7.05078 6.75781 6.91406 6.75781ZM6.91406 8.94531H6.0026C5.8431 8.94531 5.72917 9.08203 5.72917 9.21875V10.1302C5.72917 10.2897 5.8431 10.4036 6.0026 10.4036H6.91406C7.05078 10.4036 7.1875 10.2897 7.1875 10.1302V9.21875C7.1875 9.08203 7.05078 8.94531 6.91406 8.94531Z"
                    />
                  </svg>
                  <div>
                    {{
                      authUser.user.role === "doctor"
                        ? "Physician"
                        : authUser.user.role === "hospital_administrator"
                        ? "Hospital"
                        : authUser.user.role === "clinic_administrator"
                        ? "Clinic"
                        : authUser.user.role === "nfp_administrator"
                        ? "Non-For-Profit"
                        : authUser.user.role === "hcp"
                        ? "Advanced Medical Professional"
                        : authUser.user.role
                    }}
                  </div>
                </div>
                <div class="tags" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }" v-if="userValues.user_info.speciality">
                  {{ userValues.user_info.speciality }}
                </div>
                <div class="tags" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }" v-if="tag">
                  {{ tag }}
                </div>
              </div>
              <p
                :style="{ color: '#0F1734', 'font-weight': '700', 'font-size': '14px', 'line-height': '21px', 'padding-bottom': '13px' }"
                v-if="authUser.user.location && authUser.user.location[0].city"
                class="m-0 doc-loc text-truncate"
              >
                <font-awesome-icon size="1x" :style="{ color: '#0F1734' }" :icon="['fal', 'map-marker-alt']" />
                {{ authUser.user.location[0].city }},
                {{ authUser.user.location[0].state }}
              </p>

              <p :style="{ 'margin-bottom': '0px' }" v-if="authUser.user.role !== 'nfp_administrator'">
                <ReviewStar :rating="totalRating.toFixed(2)" :width="30" :height="30" />
              </p>
              <p
                :style="{ 'font-weight': '400', 'font-size': '14px', 'line-height': '21px', color: '#0F1734', 'margin-top': '6px !important', 'margin-bottom': '0px !important' }"
                v-if="authUser.user.role !== 'nfp_administrator'"
              >
                {{ totalRating.toFixed(2) }}
                <!-- {{ userValues.rating ? userValues.rating.toFixed(2) : userValues.overall_rating ? userValues.overall_rating.toFixed(2) : 0 }} -->
                stars -
                {{ totalRevCount }}
                <!-- {{ userValues.reviews_count ? userValues.reviews_count : "0" }} -->
                reviews
              </p>

              <div class="font14 gray500 mt-3 text-left" v-if="userValues.user_info.joined_date">Member since: {{ formatDate(userValues.user_info.joined_date) }}</div>
            </div>
            <div class="stat-cont">
              <div class="statistics">
                <div class="circle-mem">
                  <span class="num">{{ userValues.recommendations ? userValues.recommendations : 0 }}</span>
                  <span class="num-text">Recommendations</span>
                </div>
                <template v-if="authUser.user.role !== 'nfp_administrator'">
                  <div class="vertical-seperator"></div>
                  <div class="circle-on">
                    <span class="num">{{ totalRevCount }}</span>
                    <!-- <span class="num">{{ userValues.reviews_count ? userValues.reviews_count : 0 }}</span> -->
                    <span class="num-text">Reviews</span>
                  </div>
                </template>
              </div>

              <div class="statistics">
                <div class="circle-mem">
                  <span class="num">{{ userValues.no_of_members ? userValues.no_of_members : 0 }}</span>
                  <span class="num-text">Circle Members</span>
                </div>
                <div class="vertical-seperator"></div>
                <div class="circle-on">
                  <span class="num"> {{ userValues.no_of_circle_on }}</span>
                  <span class="num-text">Circle On</span>
                </div>
              </div>
            </div>
          </div>
          <!-- RIGHT CONTENT -->

          <div class="nav-sec p-4">
            <div class="mt-1 profile-tabs sort-dropdown">
              <!-- Psoriasis/profile/view/hcp/251/updates -->
              <div
                id="updates"
                :class="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/updates` ? 'active-tabs cp' : 'tabs cp'"
                :style="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/updates` ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }"
                @click="handletab($event)"
              >
                Updates
              </div>
              <div
                id="about"
                :class="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/about` ? 'active-tabs cp' : 'tabs cp'"
                :style="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/about` ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }"
                @click="handletab($event)"
              >
                About
              </div>
              <div
                id="dovedaily"
                v-if="authUser.user.role === 'patient' || authUser.user.role === 'caregiver'"
                :class="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/dovedaily` ? 'active-tabs cp' : 'tabs cp'"
                :style="
                  this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/dovedaily` ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }
                "
                @click="handletab($event)"
              >
                DoveDaily
              </div>
              <div
                id="circles"
                :class="
                  this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/circles/allCircleMembers` ||
                  this.$route.path.includes('self') ||
                  this.$route.path.includes('hospitals') ||
                  this.$route.path.includes('clinics') ||
                  this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/circles/nfp` ||
                  this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/circles/hcp` ||
                  this.$route.path.includes('providers')
                    ? 'active-tabs cp'
                    : 'tabs cp'
                "
                :style="
                  this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/circles/allCircleMembers` ||
                  this.$route.path.includes('self') ||
                  this.$route.path.includes('hospitals') ||
                  this.$route.path.includes('clinics') ||
                  this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/circles/nfp` ||
                  this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/circles/hcp` ||
                  this.$route.path.includes('providers')
                    ? { color: getPrimaryColor(), background: getPrimary50Color() }
                    : { color: '#0F1734' }
                "
                @click="handletab($event)"
              >
                Circles
              </div>
              <a-dropdown :trigger="['click']" v-model="displayDots2W" :getPopupContainer="trigger => trigger.parentNode">
                <div
                  :style="
                    this.$route.path.includes('qa') ||
                    this.$route.path.includes('polls') ||
                    this.$route.path.includes('saved') ||
                    this.$route.path.includes('profilerev') ||
                    this.$route.path.includes('receivedreviews') ||
                    this.$route.path.includes('medrev') ||
                    this.$route.path.includes('profilercmnd') ||
                    this.$route.path.includes('treatmentrcmnd')
                      ? { color: getPrimaryColor(), background: getPrimary50Color() }
                      : { color: '#0F1734' }
                  "
                  id="reviews"
                  :class="
                    this.$route.path.includes('qa') ||
                    this.$route.path.includes('polls') ||
                    this.$route.path.includes('saved') ||
                    this.$route.path.includes('profilerev') ||
                    this.$route.path.includes('receivedreviews') ||
                    this.$route.path.includes('medrev') ||
                    this.$route.path.includes('profilercmnd') ||
                    this.$route.path.includes('treatmentrcmnd')
                      ? 'active-tabs'
                      : 'tabs'
                  "
                >
                  <div
                    :style="
                      this.$route.path.includes('qa') ||
                      this.$route.path.includes('polls') ||
                      this.$route.path.includes('saved') ||
                      this.$route.path.includes('profilerev') ||
                      this.$route.path.includes('medrev') ||
                      this.$route.path.includes('receivedreviews') ||
                      this.$route.path.includes('profilercmnd') ||
                      this.$route.path.includes('treatmentrcmnd')
                        ? { color: getPrimaryColor() }
                        : ''
                    "
                    class="tabe"
                  >
                    <!-- {{ selectedTab }} -->
                    {{ "Reviews & More" }}
                    <font-awesome-icon size="1x" :icon="displayDots2W ? ['far', 'angle-up'] : ['far', 'angle-down']" class="mr-2" />
                  </div>
                </div>
                <template #overlay>
                  <a-menu>
                    <a-menu-item
                      id="qa"
                      @click="
                        () => {
                          selectedTab = 'QA'
                          $router.push({
                            path: `/${currentCircle.key_name}/profile/${authUser.user.role}/qa`,
                          })
                        }
                      "
                      class="card-item"
                    >
                      Q&A
                    </a-menu-item>
                    <a-menu-item
                      id="polls"
                      @click="
                        () => {
                          selectedTab = 'Polls'
                          $router.push({
                            path: `/${currentCircle.key_name}/profile/${authUser.user.role}/polls`,
                          })
                        }
                      "
                      class="card-item"
                    >
                      Polls
                    </a-menu-item>
                    <a-menu-item
                      @click="
                        () => {
                          selectedTab = 'Saved'
                          $router.push({
                            path: `/${currentCircle.key_name}/profile/${authUser.user.role}/saved`,
                          })
                        }
                      "
                      class="card-item"
                    >
                      Saved
                    </a-menu-item>
                    <a-menu-item
                      id="medrev"
                      @click="
                        () => {
                          selectedTab = 'Medication Reviews'
                          $router.push({
                            path: `/${currentCircle.key_name}/profile/${authUser.user.role}/medrev`,
                          })
                        }
                      "
                      class="card-item"
                    >
                      Medication Reviews
                    </a-menu-item>
                    <a-menu-item
                      id="profilercmnd"
                      @click="
                        () => {
                          selectedTab = 'Profile Recommendations'
                          $router.push({
                            path: `/${currentCircle.key_name}/profile/${authUser.user.role}/profilercmnd`,
                          })
                        }
                      "
                      class="card-item"
                    >
                      Profile Recommendations
                    </a-menu-item>
                    <a-menu-item
                      id="treatmentrcmnd"
                      @click="
                        () => {
                          selectedTab = 'Treatment Recommendations'
                          $router.push({
                            path: `/${currentCircle.key_name}/profile/${authUser.user.role}/treatmentrcmnd`,
                          })
                        }
                      "
                      class="card-item"
                    >
                      Treatment Recommendations
                    </a-menu-item>
                    <a-menu-item
                      id="profilercmnd"
                      @click="
                        () => {
                          selectedTab = 'Muted User'
                          $router.push({
                            path: `/${currentCircle.key_name}/profile/${authUser.user.role}/muteduser`,
                          })
                        }
                      "
                      class="card-item"
                    >
                      Muted Users
                    </a-menu-item>
                    <a-menu-item
                      id="receivedreviews"
                      @click="
                        () => {
                          selectedTab = 'Received Reviews'
                          $router.push({ path: `/${currentCircle.key_name}/profile/${authUser.user.role}/receivedreviews/all` })
                        }
                      "
                      class="card-item"
                      v-if="authUser.user.role !== 'nfp_administrator'"
                    >
                      Received Reviews
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </div>
          </div>
        </div>
      </div>

      <!-- mobile responsive view -->
      <div class="circle-card m-prof position-relative">
        <div class="circle-card-content text-center position-relative">
          <div class="camera-icon-button profile-bg-mob h-100" :style="{ position: 'relative', top: '0px', right: '80px' }">
            <button class="threedot-menu-edited-mob-doc" style="top: 70px; right: 0px" @click="() => $refs.drawerBackgroundRef.show()">
              <div class="dot-menu-cont">
                <div class="camera-icon-btn">
                  <label class="camera-bttn cp d-flex justify-content-center align-items-center" aria-hidden="true" :style="{ background: getPrimaryColor() }">
                    <font-awesome-icon
                      size="2x"
                      :style="{
                        color: 'white !important',
                        transform: 'scale(0.5)',
                        height: '100%',
                      }"
                      :icon="['fas', 'camera']"
                    />
                  </label>
                </div>
              </div>
            </button>
          </div>
          <button
            class="threedot-menu mob"
            :style="{
              background: '#fff',
              border: 'none',
              display: 'flex',
              'align-self': 'flex-end',
            }"
            @click="() => $refs.drawerShareRef.show()"
          >
            <font-awesome-icon
              size="1x"
              :style="{
                color: '#94A3B8',
              }"
              :icon="['fas', 'ellipsis-v']"
            />
          </button>
          <!-- <a-avatar :size="100" icon="user" :src="authUser.user.url" alt="" /> -->
          <a-avatar
            :style="{
              color: ' #ffffff !important',
              'background-color': authUser.user.url ? authUser.user.url : '' ? '' : '#C997C5',
            }"
            :size="160"
            :src="authUser.user.url || authUser.user.picture"
            class="text-capitalize"
          >
            {{ authUser.user.display_name[0] }}
          </a-avatar>
          <!-- <span
            class="rating-box"
            :style="{ background: getPrimaryColor() }"
            v-if="
              authUser.user.role === 'doctor' || authUser.user.role === 'hcp'
            "
          >
            <a-icon class="star-rating" type="star" theme="filled" />
            <span class="rating-text">{{ Math.floor(userRating) }}</span>
          </span> -->
          <!-- <div class="camera-icon-button">
            <label
              class="camera-btn cp d-flex justify-content-center align-items-center"
              aria-hidden="true"
              :style="{ background: getPrimaryColor(), zIndex: 10 }"
            >
              <font-awesome-icon
                size="2x"
                :style="{ transform: 'scale(0.7)', color: 'white !important', }"
                :icon="['fas', 'camera']"
              />
              <input
                type="file"
                ref="mfile"
                @change="handleMobileProfilePicUpload()" 
              />
            </label>
          </div> -->

          <div class="d-flex flex-row" v-if="authUser.user.is_verified" :style="{ 'margin-top': '26px' }">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :style="{ 'margin-right': '8px' }">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.6458 0.648784C10.9757 0.238571 11.4736 0 11.9998 0C12.526 0 13.0239 0.238571 13.3537 0.648784L14.9657 2.65518C15.3367 3.11777 15.9179 3.35907 16.5072 3.29518L19.0659 3.01678C19.5905 2.95846 20.1132 3.14192 20.4865 3.51539C20.8598 3.88886 21.0431 4.41184 20.9848 4.93677L20.7066 7.49676C20.6427 8.08643 20.8839 8.66795 21.3462 9.03916L23.3516 10.652C23.7616 10.982 24 11.4801 24 12.0066C24 12.5331 23.7616 13.0312 23.3516 13.3613L21.3398 14.9666C20.8776 15.3384 20.6366 15.9201 20.7002 16.5101L20.9784 19.0701C21.0371 19.5951 20.8539 20.1183 20.4805 20.4919C20.1072 20.8655 19.5842 21.0488 19.0595 20.9901L16.5008 20.7117C15.9115 20.6476 15.3301 20.8889 14.9593 21.3517L13.3537 23.3506C13.0241 23.7612 12.5261 24 11.9998 24C11.4734 24 10.9755 23.7612 10.6458 23.3506L9.03497 21.3453C8.66351 20.8826 8.08199 20.6414 7.49234 20.7053L4.93371 20.9837C4.40886 21.0428 3.88565 20.8596 3.51218 20.4859C3.1387 20.1123 2.95562 19.5888 3.01474 19.0637L3.29299 16.5037C3.35682 15.9137 3.11569 15.3319 2.65333 14.9602L0.649074 13.3485C0.238717 13.0187 0 12.5205 0 11.9938C0 11.4672 0.238717 10.969 0.649074 10.6392L2.65333 9.02636C3.11584 8.65528 3.35705 8.07366 3.29299 7.48396L3.01474 4.92397C2.95604 4.39894 3.13926 3.8757 3.51263 3.50214C3.886 3.12857 4.40896 2.94524 4.93371 3.00398L7.49234 3.28238C8.08196 3.34604 8.66338 3.10482 9.03497 2.64238L10.6458 0.648784Z"
                fill="#00C853"
              />
              <path
                d="M16.5 9L12.0214 15.3893C11.8746 15.5985 11.6502 15.7293 11.4063 15.7477C11.1624 15.7662 10.923 15.6706 10.7501 15.4856L8.0625 12.6112"
                stroke="white"
                stroke-width="2.08333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <p :style="{ 'font-weight': '700', 'font-size': '16px', 'line-height': '24px', color: '#00C853' }">Verified & Claimed</p>
          </div>
          <div class="doc-info">
            <h5 class="m-0 doc-name text-capitalize" v-if="authUser">
              {{ authUser.user.display_name }}
              <!-- {{ userValues.user_info.title ? "," + userValues.user_info.title : "" }} -->
            </h5>
            <p class="m-0 doc-name text-capitalize">
              {{ authUser.hospital_name }}
            </p>
            <div class="tag-cont">
              <div class="physician-tag">
                <font-awesome-icon v-if="authUser.user.role === 'hcp'" class="tag-icon-oran" :icon="['far', 'user-nurse']" :style="{ fill: '#F5A623' }" />
                <font-awesome-icon v-if="authUser.user.role === 'nfp_administrator'" class="tag-icon-oran" :icon="['far', 'hand-holding-heart']" :style="{ fill: '#F5A623' }" />
                <svg v-if="authUser.user.role === 'doctor'" :style="{ fill: '#F5A623' }" class="tag-icon-oran" width="10" height="12" viewBox="0 0 10 12" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3.0835 3.11198C3.0835 1.51693 4.38232 0.195312 6.00016 0.195312C7.59521 0.195312 8.91683 1.51693 8.91683 3.11198C8.91683 4.72982 7.59521 6.02865 6.00016 6.02865C4.38232 6.02865 3.0835 4.72982 3.0835 3.11198ZM7.82308 3.11198C7.82308 2.10938 7.00277 1.28906 6.00016 1.28906C4.97477 1.28906 4.17725 2.10938 4.17725 3.11198C4.17725 4.13737 4.97477 4.9349 6.00016 4.9349C7.00277 4.9349 7.82308 4.13737 7.82308 3.11198ZM4.54183 9.37826C5.06592 9.53776 5.45329 10.0163 5.45329 10.5859C5.45329 11.2923 4.86084 11.862 4.17725 11.862C3.47087 11.862 2.9012 11.2923 2.9012 10.5859C2.9012 10.0163 3.26579 9.53776 3.81266 9.37826V8.44401C2.7417 8.87695 1.98975 9.92513 1.98975 11.1328V11.3151C1.98975 11.6341 1.7391 11.862 1.44287 11.862C1.12386 11.862 0.895996 11.6341 0.895996 11.3151V11.1328C0.895996 8.92253 2.67334 7.1224 4.90641 7.1224H7.09391C9.3042 7.1224 11.1043 8.92253 11.1043 11.1328V11.3151C11.1043 11.6341 10.8537 11.862 10.5575 11.862C10.2384 11.862 10.0106 11.6341 10.0106 11.3151V11.1328C10.0106 9.92513 9.23584 8.87695 8.18766 8.44401V9.37826C8.71175 9.53776 9.09912 10.0163 9.09912 10.5859V11.3151C9.09912 11.5202 8.91683 11.6797 8.73454 11.6797C8.52946 11.6797 8.36995 11.5202 8.36995 11.3151V10.5859C8.36995 10.2897 8.1193 10.0391 7.82308 10.0391C7.50407 10.0391 7.2762 10.2897 7.2762 10.5859V11.3151C7.2762 11.5202 7.09391 11.6797 6.91162 11.6797C6.70654 11.6797 6.54704 11.5202 6.54704 11.3151V10.5859C6.54704 10.0163 6.91162 9.53776 7.4585 9.37826V8.23893C7.32178 8.23893 7.20784 8.21615 7.09391 8.21615H4.90641C4.76969 8.21615 4.65576 8.23893 4.54183 8.23893V9.37826ZM4.17725 11.1328C4.47347 11.1328 4.72412 10.9049 4.72412 10.5859C4.72412 10.2897 4.47347 10.0391 4.17725 10.0391C3.85824 10.0391 3.63037 10.2897 3.63037 10.5859C3.63037 10.9049 3.85824 11.1328 4.17725 11.1328Z"
                  />
                </svg>
                <svg
                  v-if="authUser.user.role === 'hospital_administrator'"
                  :style="{ fill: '#F5A623' }"
                  class="tag-icon-oran"
                  width="14"
                  height="12"
                  viewBox="0 0 14 12"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.53906 9.67448H3.6276C3.4681 9.67448 3.35417 9.8112 3.35417 9.94792V10.8594C3.35417 11.0189 3.4681 11.1328 3.6276 11.1328H4.53906C4.67578 11.1328 4.8125 11.0189 4.8125 10.8594V9.94792C4.8125 9.8112 4.67578 9.67448 4.53906 9.67448ZM7.45573 9.67448H6.54427C6.38477 9.67448 6.27083 9.8112 6.27083 9.94792V10.8594C6.27083 11.0189 6.38477 11.1328 6.54427 11.1328H7.45573C7.59245 11.1328 7.72917 11.0189 7.72917 10.8594V9.94792C7.72917 9.8112 7.59245 9.67448 7.45573 9.67448ZM4.53906 7.48698H3.6276C3.4681 7.48698 3.35417 7.6237 3.35417 7.76042V8.67188C3.35417 8.83138 3.4681 8.94531 3.6276 8.94531H4.53906C4.67578 8.94531 4.8125 8.83138 4.8125 8.67188V7.76042C4.8125 7.6237 4.67578 7.48698 4.53906 7.48698ZM7.45573 7.48698H6.54427C6.38477 7.48698 6.27083 7.6237 6.27083 7.76042V8.67188C6.27083 8.83138 6.38477 8.94531 6.54427 8.94531H7.45573C7.59245 8.94531 7.72917 8.83138 7.72917 8.67188V7.76042C7.72917 7.6237 7.59245 7.48698 7.45573 7.48698ZM10.3724 7.48698H9.46094C9.30143 7.48698 9.1875 7.6237 9.1875 7.76042V8.67188C9.1875 8.83138 9.30143 8.94531 9.46094 8.94531H10.3724C10.5091 8.94531 10.6458 8.83138 10.6458 8.67188V7.76042C10.6458 7.6237 10.5091 7.48698 10.3724 7.48698ZM12.1042 2.38281H11.375V1.67643C11.375 0.85612 10.7142 0.195312 9.91667 0.195312H4.06055C3.26302 0.195312 2.60221 0.85612 2.60221 1.67643V2.38281H1.89583C1.07552 2.38281 0.4375 3.04362 0.4375 3.84115V11.3151C0.4375 11.6341 0.665365 11.862 0.984375 11.862C1.2806 11.862 1.53125 11.6341 1.53125 11.3151V3.84115C1.53125 3.65885 1.69076 3.47656 1.89583 3.47656H3.69596V1.67643C3.69596 1.47135 3.85547 1.28906 4.06055 1.28906H9.91667C10.1217 1.28906 10.2812 1.47135 10.2812 1.67643V3.47656H12.1042C12.2865 3.47656 12.4688 3.65885 12.4688 3.84115V11.3151C12.4688 11.6341 12.6966 11.862 13.0156 11.862C13.3118 11.862 13.5625 11.6341 13.5625 11.3151V3.84115C13.5625 3.04362 12.9017 2.38281 12.1042 2.38281ZM10.3724 9.67448H9.46094C9.30143 9.67448 9.1875 9.8112 9.1875 9.94792V10.8594C9.1875 11.0189 9.30143 11.1328 9.46094 11.1328H10.3724C10.5091 11.1328 10.6458 11.0189 10.6458 10.8594V9.94792C10.6458 9.8112 10.5091 9.67448 10.3724 9.67448ZM8.57227 3.47656H7.72917V2.63346C7.72917 2.49674 7.61523 2.38281 7.47852 2.38281H6.4987C6.36198 2.38281 6.27083 2.49674 6.27083 2.63346V3.47656H5.40495C5.26823 3.47656 5.17708 3.5905 5.17708 3.72721V4.70703C5.17708 4.84375 5.26823 4.9349 5.40495 4.9349H6.27083V5.80078C6.27083 5.9375 6.36198 6.02865 6.4987 6.02865H7.47852C7.61523 6.02865 7.72917 5.9375 7.72917 5.80078V4.9349H8.57227C8.70898 4.9349 8.82292 4.84375 8.82292 4.70703V3.72721C8.82292 3.5905 8.70898 3.47656 8.57227 3.47656Z"
                  />
                </svg>
                <svg
                  v-if="authUser.user.role === 'clinic_administrator'"
                  :style="{ fill: '#F5A623' }"
                  class="tag-icon-oran"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.45833 4.2513V3.45378C6.45833 3.36263 6.36719 3.27148 6.25325 3.27148H5.56966V2.58789C5.56966 2.47396 5.47852 2.38281 5.38737 2.38281H4.58984C4.4987 2.38281 4.40755 2.47396 4.40755 2.58789V3.27148H3.72396C3.61003 3.27148 3.54167 3.36263 3.54167 3.45378V4.2513C3.54167 4.34245 3.61003 4.43359 3.72396 4.43359H4.40755V5.11719C4.40755 5.23112 4.4987 5.29948 4.58984 5.29948H5.38737C5.47852 5.29948 5.56966 5.23112 5.56966 5.11719V4.43359H6.25325C6.36719 4.43359 6.45833 4.34245 6.45833 4.2513ZM3.9974 6.75781H3.08594C2.92643 6.75781 2.8125 6.89453 2.8125 7.03125V7.94271C2.8125 8.10221 2.92643 8.21615 3.08594 8.21615H3.9974C4.13411 8.21615 4.27083 8.10221 4.27083 7.94271V7.03125C4.27083 6.89453 4.13411 6.75781 3.9974 6.75781ZM3.9974 8.94531H3.08594C2.92643 8.94531 2.8125 9.08203 2.8125 9.21875V10.1302C2.8125 10.2897 2.92643 10.4036 3.08594 10.4036H3.9974C4.13411 10.4036 4.27083 10.2897 4.27083 10.1302V9.21875C4.27083 9.08203 4.13411 8.94531 3.9974 8.94531ZM7.91667 0.195312H2.08333C1.26302 0.195312 0.625 0.85612 0.625 1.65365V11.3151C0.625 11.6341 0.852865 11.862 1.17188 11.862C1.4681 11.862 1.71875 11.6341 1.71875 11.3151V1.65365C1.71875 1.47135 1.87826 1.28906 2.08333 1.28906H7.91667C8.09896 1.28906 8.28125 1.47135 8.28125 1.65365V11.3151C8.28125 11.6341 8.50911 11.862 8.82812 11.862C9.12435 11.862 9.375 11.6341 9.375 11.3151V1.65365C9.375 0.85612 8.71419 0.195312 7.91667 0.195312ZM6.91406 6.75781H6.0026C5.8431 6.75781 5.72917 6.89453 5.72917 7.03125V7.94271C5.72917 8.10221 5.8431 8.21615 6.0026 8.21615H6.91406C7.05078 8.21615 7.1875 8.10221 7.1875 7.94271V7.03125C7.1875 6.89453 7.05078 6.75781 6.91406 6.75781ZM6.91406 8.94531H6.0026C5.8431 8.94531 5.72917 9.08203 5.72917 9.21875V10.1302C5.72917 10.2897 5.8431 10.4036 6.0026 10.4036H6.91406C7.05078 10.4036 7.1875 10.2897 7.1875 10.1302V9.21875C7.1875 9.08203 7.05078 8.94531 6.91406 8.94531Z"
                  />
                </svg>
                <div>
                  {{
                    authUser.user.role === "doctor"
                      ? "Physician"
                      : authUser.user.role === "hospital_administrator"
                      ? "Hospital"
                      : authUser.user.role === "clinic_administrator"
                      ? "clinic"
                      : authUser.user.role === "nfp_administrator"
                      ? "Non-For-Profit"
                      : authUser.user.role === "hcp"
                      ? "Advanced Medical Professional"
                      : authUser.user.role
                  }}
                </div>
              </div>
              <div
                class="tags"
                :style="{
                  color: getPrimaryColor(),
                  background: getPrimary50Color(),
                }"
                v-if="userValues.user_info.speciality"
              >
                {{ userValues.user_info.speciality }}
              </div>
              <div
                class="tags"
                :style="{
                  color: getPrimaryColor(),
                  background: getPrimary50Color(),
                }"
                v-if="tag"
              >
                {{ tag }}
              </div>
            </div>
            <p
              v-if="authUser.user.location && authUser.user.location[0].city"
              :style="{
                color: '#0F1734',
                'font-weight': '700',
                'font-size': '14px',
                'line-height': '21px',
                'margin-bottom': '13px !important',
              }"
              class="m-0 doc-loc text-truncate"
            >
              <font-awesome-icon
                size="1x"
                :style="{
                  color: '#0F1734',
                }"
                :icon="['fal', 'map-marker-alt']"
              />
              {{ authUser.user.location[0].city }},
              {{ authUser.user.location[0].state }}
            </p>
            <p :style="{ 'margin-bottom': '0px' }" class="d-flex" v-if="authUser.user.role !== 'nfp_administrator'">
              <ReviewStar :rating="totalRating.toFixed(2)" :width="30" :height="30" />
              <!-- <ReviewStarforcircle :rating="totalRating.toFixed(2)" /> -->
            </p>
            <p :style="{ 'line-height': '21px', color: '#0F1734', 'margin-top': '6px !important' }" v-if="authUser.user.role !== 'nfp_administrator'" class="stars fw400 font14 mb-0">
              {{ totalRating.toFixed(2) }}
              <!-- {{ userValues.rating ? userValues.rating.toFixed(2) : userValues.overall_rating ? userValues.overall_rating.toFixed(2) : 0 }} -->
              stars -
              {{ totalRevCount }}
              <!-- {{ userValues.reviews_count ? userValues.reviews_count : 0 }} -->
              reviews
            </p>

            <div class="font14 gray500 mt-3 text-left" v-if="userValues.user_info.joined_date">Member since: {{ formatDate(userValues.user_info.joined_date) }}</div>

            <!-- <p
              class="m-0 recommendations hyper-link"
              :style="{ color: getPrimaryColor() }"
            >
              {{ circleMembersCount }} circle members
            </p> -->

            <!-- CIRCLE MEMBERS BOX -->

            <div class="stat-cont">
              <div class="statistics">
                <div class="circle-mem">
                  <span class="num">{{ userValues.recommendations ? userValues.recommendations : 0 }}</span>
                  <span class="num-text">Recommendations</span>
                </div>
                <template v-if="authUser.user.role !== 'nfp_administrator'">
                  <div class="vertical-seperator"></div>
                  <div class="circle-on">
                    <span class="num">{{ totalRevCount }}</span>
                    <!-- <span class="num">{{ userValues.reviews_count ? userValues.reviews_count : 0 }}</span> -->
                    <span class="num-text">Reviews</span>
                  </div>
                </template>
              </div>

              <div class="statistics">
                <div class="circle-mem">
                  <span class="num">{{ userValues.no_of_members ? userValues.no_of_members : 0 }}</span>
                  <span class="num-text">Circle Members</span>
                </div>
                <div class="vertical-seperator"></div>
                <div class="circle-on">
                  <span class="num"> {{ userValues.no_of_circle_on }}</span>
                  <span class="num-text">Circle On</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="m-prof-sub">
        <ul class="sub-nav text-center sort-dropdown" :style="{ 'margin-bottom': '0px', display: 'flex' }">
          <li
            :style="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/updates` ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }"
            id="updates"
            :class="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/updates` ? 'active-tabs' : 'tabs'"
            @click="handletab($event)"
          >
            Updates
          </li>
          <li
            :style="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/about` ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }"
            id="about"
            :class="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/about` ? 'active-tabs' : 'tabs'"
            @click="handletab($event)"
          >
            About
          </li>
          <li
            :style="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/dovedaily` ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }"
            id="dovedaily"
            :class="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/dovedaily` ? 'active-tabs' : 'tabs'"
            @click="handletab($event)"
            v-if="authUser.user.role === 'patient' || authUser.user.role === 'caregiver'"
          >
            DoveDaily
          </li>
          <li
            :style="
              this.$route.path.includes('ViewAllCircle') ||
              this.$route.path.includes('allCircleMembers') ||
              this.$route.path.includes('self') ||
              this.$route.path.includes('hospitals') ||
              this.$route.path.includes('clinics') ||
              this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/circles/nfp` ||
              this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/circles/hcp` ||
              this.$route.path.includes('providers')
                ? { color: getPrimaryColor(), background: getPrimary50Color() }
                : { color: '#0F1734' }
            "
            id="circles"
            :class="
              this.$route.path.includes('ViewAllCircle') ||
              this.$route.path.includes('allCircleMembers') ||
              this.$route.path.includes('self') ||
              this.$route.path.includes('hospitals') ||
              this.$route.path.includes('clinics') ||
              this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/circles/nfp` ||
              this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/circles/hcp` ||
              this.$route.path.includes('providers')
                ? 'active-tabs'
                : 'tabs'
            "
            @click="handletab($event)"
          >
            Circles
          </li>
            <div
              @click="() => $refs.drawerMenuRef.show()"
              :style="
                this.$route.path.includes('qa') ||
                this.$route.path.includes('polls') ||
                this.$route.path.includes('saved') ||
                this.$route.path.includes('profilerev') ||
                this.$route.path.includes('medrev') ||
                this.$route.path.includes('profilercmnd') ||
                this.$route.path.includes('receivedreviews') ||
                this.$route.path.includes('treatmentrcmnd')
                  ? { color: getPrimaryColor(), background: getPrimary50Color() }
                  : { color: '#0F1734' }
              "
              id="reviews"
              :class="
                this.$route.path.includes('qa') ||
                this.$route.path.includes('polls') ||
                this.$route.path.includes('saved') ||
                this.$route.path.includes('profilerev') ||
                this.$route.path.includes('medrev') ||
                this.$route.path.includes('profilercmnd') ||
                this.$route.path.includes('receivedreviews') ||
                this.$route.path.includes('treatmentrcmnd')
                  ? 'active-tabs'
                  : 'tabs'
              "
            >
              <div
                :style="
                  this.$route.path.includes('qa') ||
                  this.$route.path.includes('polls') ||
                  this.$route.path.includes('saved') ||
                  this.$route.path.includes('profilerev') ||
                  this.$route.path.includes('medrev') ||
                  this.$route.path.includes('receivedreviews') ||
                  this.$route.path.includes('profilercmnd') ||
                  this.$route.path.includes('treatmentrcmnd')
                    ? { color: getPrimaryColor() }
                    : ''
                "
                class="tabe"
              >
                <!-- {{ selectedTab }} -->
                {{ "Reviews & More" }}
                <font-awesome-icon size="1x" :icon="displayDots2M ? ['far', 'angle-up'] : ['far', 'angle-down']" class="mr-2" />
              </div>
            </div>
            <DrawerModal ref="drawerMenuRef">
              <div @click="() => $refs.drawerMenuRef.close()">
                <a-menu-item
                  id="qa"
                  @click="
                    () => {
                      selectedTab = 'Q&A'
                      $router.push({
                        path: `/${currentCircle.key_name}/profile/${authUser.user.role}/qa`,
                      })
                    }
                  "
                  class="drawer-item py-2"
                >
                  Q&A
                </a-menu-item>
                <a-menu-item
                  id="polls"
                  @click="
                    () => {
                      selectedTab = 'Polls'
                      $router.push({
                        path: `/${currentCircle.key_name}/profile/${authUser.user.role}/polls`,
                      })
                    }
                  "
                  class="drawer-item py-2"
                >
                  Polls
                </a-menu-item>
                <a-menu-item
                  id="saved"
                  @click="
                    () => {
                      selectedTab = 'Saved'
                      $router.push({
                        path: `/${currentCircle.key_name}/profile/${authUser.user.role}/saved`,
                      })
                    }
                  "
                  class="drawer-item py-2"
                >
                  Saved
                </a-menu-item>
                <a-menu-item
                  id="medrev"
                  @click="
                    () => {
                      selectedTab = 'Medication Reviews'
                      $router.push({
                        path: `/${currentCircle.key_name}/profile/${authUser.user.role}/medrev`,
                      })
                    }
                  "
                  class="drawer-item py-2"
                >
                  Medication Reviews
                </a-menu-item>
                <a-menu-item
                  id="profilercmnd"
                  @click="
                    () => {
                      selectedTab = 'Profile Recommendations'
                      $router.push({
                        path: `/${currentCircle.key_name}/profile/${authUser.user.role}/profilercmnd`,
                      })
                    }
                  "
                  class="drawer-item py-2"
                >
                  Profile Recommendations
                </a-menu-item>
                <a-menu-item
                  id="treatmentrcmnd"
                  @click="
                    () => {
                      selectedTab = 'Treatment Recommendations'
                      $router.push({
                        path: `/${currentCircle.key_name}/profile/${authUser.user.role}/treatmentrcmnd`,
                      })
                    }
                  "
                  class="drawer-item py-2"
                >
                  Treatment Recommendations
                </a-menu-item>
                <a-menu-item
                  id="profilercmnd"
                  @click="
                    () => {
                      selectedTab = 'Muted User'
                      $router.push({
                        path: `/${currentCircle.key_name}/profile/${authUser.user.role}/muteduser`,
                      })
                    }
                  "
                  class="drawer-item py-2"
                >
                  Muted Users
                </a-menu-item>
                <a-menu-item
                  id="receivedreviews"
                  @click="
                    () => {
                      selectedTab = 'Received Reviews'
                      $router.push({ path: `/${currentCircle.key_name}/profile/${authUser.user.role}/receivedreviews/all` })
                    }
                  "
                  class="drawer-item py-2"
                  v-if="authUser.user.role !== 'nfp_administrator'"
                >
                  Received Reviews
                </a-menu-item>
              </div>
          </DrawerModal>
        </ul>
      </div>
      <div class="dovemed-wrapper m-prof-wrapper py-4 padding-fix">
        <div class="row">
          <div class="col-md-4 col-lg-4 d-prof-progress">
            <!-- <div class='ad-container'></div> -->
          </div>
          <div class="col-md-8 col-lg-8 col-sm-12 col-xs-12 mag">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>

    <AvatarModal ref="avatarModal" :handleProfilePic="handleProfilePic" />
    <ProfileImageGalleryVue ref="profileImageGalleryModal" :handleLoader="handleLoader" />
    <BackgroundImageGallery :handleLoader="handleLoaderBg" ref="bgImageGalleryModal" />
    <ShareProfileModal ref="ShareProfileModal" />
    <DrawerModal ref="drawerBackgroundRef">
      <div class="pb-2" @click="() => $refs.drawerBackgroundRef.close()">
        <p class="drawer-item" @click="() => $refs.bgImageGalleryModal.show(backgroundImages)">
          <font-awesome-icon size="1x" :icon="['fal', 'images']" class="mr-2" />
          Select image
        </p>
        <p class="drawer-item position-relative">
          <font-awesome-icon size="1x" :icon="['fal', 'arrow-from-bottom']" class="mr-2" />
          <input
            title=""
            class="camera-icon-inp position-absolute w-100 h-100"
            type="file"
            accept="image/png, image/jpeg, image/gif, image/svg+xml"
            ref="Mbg"
            @change="handleMBackgroundPicUpload()"
            :style="{ left: '0', opacity: '0' }"
          />
          Upload image
        </p>
        <p class="divider mb-0"></p>
        <p :class="`drawer-item ${authUser.user.bg_img ? '' : 'disabled-remove-bg-btn'}`" @click="removebgImage()">
          <font-awesome-icon size="1x" :icon="['fal', 'trash']" class="mr-2" />
          Remove
        </p>
      </div>
    </DrawerModal>
    <DrawerModal ref="drawerShareRef">
      <div class="pb-2" @click="() => $refs.drawerShareRef.close()">
        <p class="drawer-item d-flex flex-row" :style="{ 'font-weight': '500', color: 'black' }" @click="() => $refs.ShareProfileModal.showModal()">
          <svg width="20" height="20" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
            <path
              d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
              fill="black"
            /></svg
          >Share Profile
        </p>
      </div>
    </DrawerModal>
  </div>
</template>

<script>
import DoctorAbout from "./DoctorAbout"
import DoctorCircles from "./DoctorCircles"
import DoctorUpdates from "./DoctorUpdates"
import DoctorQA from "./DoctorQA"
import DoctorFav from "./DoctorFavorites"
import DoctorReview from "./DoctorReviews.vue"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import BackgroundImageGallery from "../../Modals/BackgroundImageGallery"
import ProfileImageGalleryVue from "../../Modals/ProfileImageGallery.vue"
import AvatarModal from "../../Modals/UserAvatarCreationModal.vue"
import s3Upload from "../../../utilities/imageUploader"
import { mapGetters } from "vuex"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faMapMarkerAlt } from "@fortawesome/pro-light-svg-icons"
// import ReviewStarforcircle from "./reviewstarforcircle.vue"
import ShareProfileModal from "../../Modals/ShareProfileModal.vue"
import { faAngleDown, faAngleUp } from "@fortawesome/pro-regular-svg-icons"
import { faBullhorn, faHospital, faHospitalSymbol, faHandHoldingHeart, faHandHeart, faUser, faUserMd, faHospitalAlt, faUserNurse } from "@fortawesome/pro-regular-svg-icons"
import ReviewStar from "../../commons/ReviewStar.vue"
// import moment from "moment"
import DrawerModal from "../../Modals/DrawerModal.vue"

library.add(faMapMarkerAlt, faAngleDown, faAngleUp, faBullhorn, faHandHoldingHeart, faUser, faUserMd, faHospitalAlt, faHospitalSymbol, faUserNurse, faHospital, faHandHeart)
const UserRepository = RepositoryFactory.get("user")
const AppRepository = RepositoryFactory.get("app")

export default {
  name: "DoctorProfile",
  components: {
    DoctorUpdates,
    DoctorAbout,
    DoctorCircles,
    DoctorReview,
    DoctorQA,
    DoctorFav,
    BackgroundImageGallery,
    ProfileImageGalleryVue,
    AvatarModal,
    ReviewStar,
    ShareProfileModal,
    DrawerModal,
    // ReviewStarforcircle,
    // ReviewStar1,
  },
  data() {
    return {
      apiDoc: "https://gist.githubusercontent.com/AbhijitKulkarni95/20a0421d6ad908fae1372c0efad9b4a4/raw/01c32d97571458bb0ca9ef730bb15227e114c69b/doctor_prof.json",
      apiPat: "https://gist.githubusercontent.com/AbhijitKulkarni95/20a0421d6ad908fae1372c0efad9b4a4/raw/01c32d97571458bb0ca9ef730bb15227e114c69b/patient_prof.json",
      profileData: null,
      cardKeys: null,
      editableData: null,
      userRating: 0,
      toDeleteKeys: ["id", "created_at", "updated_at", "is_deleted", "user", "is_verified", "npi_number", "state_licence", "licence_number"],
      recommendations: 0,
      userValues: { no_of_circle_on: undefined, no_of_members: undefined, overall_rating: undefined, rating: undefined, recommendations: undefined, reviews_count: undefined, user_info: {} },
      userInfo: {},
      tabs: { updates: true, about: false, circles: false, qa: false, fav: false },
      activeTab: "updates",
      displaypicDots: false,
      displayDots: false,
      displayprofileDots: false,
      isBackgroundImageLoading: false,
      isFetchingprofileimage: false,
      selectedTab: "Reviews & More",
      displayDots: false,
      displayDots2: false,
      displayDots2M: false,
      displayDots2W: false,
      tag: "",
      totalRating: 0,
      totalRevCount: 0,
      //currentCircle: this.$store.getters["Circle/currentCircle"],
    }
  },
  watch: {
    "authUser.user.bg_img": function() {
      // this.isBackgroundImageLoading = true
      // console.log("image changed", this.isBackgroundImageLoading, "true")
    },
    "authUser.user.url": function() {
      // console.log("image changed finished")
      this.isFetchingprofileimage = false
    },
    "authUser.user.picture": function() {
      this.isFetchingprofileimage = false
    },
    selectedTab: {
      handler() {
        this.displayDots2 = false
        this.displayDots2M = false
        this.displayDots2W = false
      },
      immediate: true,
    },
  },

  created() {
    // this.getProfile();
    this.init()
    this.getBackgroundImages()
    this.userInfo = localStorage.getItem("user-full-info")
    console.warn("DoctorProfile.vue is created")
    console.log("authUser:", this.authUser)
    console.log("viewUser:", this.viewUser)
    console.log("userInfo:", JSON.parse(this.userInfo))
    window.addEventListener("mouseup", () => {
      if (this.displaypicDots) {
        setTimeout(() => {
          this.displaypicDots = false
        }, 100)
      }
    })
  },

  computed: {
    // getUserName() {
    //   return this.$store.getters["User/user"].display_name
    // },
    ...mapGetters({
      circleMembersCount: "User/cicleMembersCount",
    }),
  },

  methods: {
    async init() {
      try {
        this.setAppLoaderStatus(true)
        const res = await UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id)
        this.userRating = res.data.data.overall_rating ? res.data.data.overall_rating : res.data.data.rating
        this.$store.commit("User/setAuthUserProfileBgImg", res.data.data.user_info)
        this.$store.commit("User/setCircleMemberCount", { data: res.data.data.no_of_members })
        this.userValues = res.data.data

        console.log("userValues:", this.userValues)

        this.recommendations = res.data.data.recommendations
        this.$store.state.User.user.user["location"] = res.data.data.user_info.location
        this.$store.state.User.user.user["display_name"] = res.data.data.user_info.display_name || "D"

        ///to get speciality other than doctor

        const aboutRes = await UserRepository.getAbout(this.authUser.user, this.currentCircle.id)
        this.profileData = aboutRes.data.data ? aboutRes.data.data[0] : {}
        const profileType = this.authUser.user.role
        switch (profileType) {
          case "hospital_administrator":
            this.tag = this.profileData.hospital_type
            break
          case "clinic_administrator":
            this.tag = this.profileData.clinic_type
            break
          case "nfp_administrator":
            this.tag = this.profileData.nfp_type
            break
          case "hcp":
            this.tag = this.profileData.speciality
            break
        }

        /**
         * Get relationship status Values and set it in store
         */
        const relRes = await AppRepository.getRelationShipStatusValues()
        this.$store.commit("User/setRelationshipStatusValues", { data: relRes.data.data })

        /**
         * Get current situation Values and set it in store
         */
        const currSit = await AppRepository.getCurrentSituationValues()
        this.$store.commit("User/setCurrentSituationValues", { data: currSit.data.data })

        this.$store.dispatch("Circle/diseaseTypes", { type: this.currentCircle.id })

        if (this.authUser.user.role !== "nfp_administrator") {
          const headers = { Authorization: `Basic ${btoa("dovemed:dovemed-rules")}`, dtoken: this.authUser.user.dovemed_csrf_token || this.authUser.user.dovemed_session_token }
          const coreRes = await this.$http.get(
            `${process.env.SSO_BASE_URL}/api/v2/review/${this.getCoreReviewApiRole(this.authUser.user.role)}/${this.authUser.user.ext_ref_id || this.authUser.user.id}/review/`,
            // `${process.env.SSO_BASE_URL}/api/v2/${this.getCoreReviewApiRole(this.authUser.user.role)}/${this.authUser.user.ext_ref_id || this.authUser.user.id}/review/`,
            { headers }
          )

          // rating - total mycircles
          // core_rating - total core

          this.totalRevCount = (this.userValues.no_of_reviews || this.userValues.reviews_count || this.userValues.review_count || 0) + (coreRes.data.count || 0)
          this.totalRating = this.userValues.rating
            ? this.userValues.overall_rating
              ? (this.userValues.rating + this.userValues.overall_rating) / 2
              : this.userValues.rating
            : this.userValues.overall_rating
        }

        this.setAppLoaderStatus(false)
      } catch (e) {
        console.log("error:", e)
        console.log("--------------------")
        console.log("error msg:", e.message)
        console.log("--------------------")
        // UserRepository.recordLogout()
        // this.$store.dispatch("Auth/logout").then(() => {
        //   location.reload()
        // })
        this.setAppLoaderStatus(false)
      }
    },

    handleLoader(val = true) {
      // console.log("handLoader()", val)
      this.isFetchingprofileimage = val
    },
    handleLoaderBg(val = true) {
      // console.log("handLoaderBg()", val)
      this.isBackgroundImageLoading = val
    },
    getBackgroundImages() {
      AppRepository.getBackgroundImageGallery().then(res => {
        this.backgroundImages = res.data.data
      })
    },

    onLoadHandler: function() {
      // console.log("onLoadHandler()")
      this.isBackgroundImageLoading = false
    },

    showOptions() {
      this.displayDots = !this.displayDots
    },

    async handleProfilePic(svgPic) {
      // console.log(svgPic, "svg")
      var svgElement = svgPic

      // Create your own image
      var img = document.createElement("img")

      // Serialize the svg to string
      var svgString = new XMLSerializer().serializeToString(svgElement)

      // Remove any characters outside the Latin1 range
      var decoded = unescape(encodeURIComponent(svgString))

      // Now we can use btoa to convert the svg to base64
      var base64 = btoa(decoded)

      var imgSource = `data:image/svg+xml;base64,${base64}`
      this.imageAva = imgSource
      this.handleAvatarPicUpload(imgSource)
      // console.log("src", imgSource)
    },

    // handle AvatarUpload
    async handleAvatarPicUpload(img) {
      console.log("handleAvatarPicUpload()")
      this.isFetchingprofileimage = true
      const file = this.authUser.user.id + Date.now().toString() + ".svg"
      try {
        const urlPayload = { file_name: [file] }
        const urlData = await UserRepository.getPresignedUrl(urlPayload)

        function dataURLtoFile(dataurl, filename) {
          var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n)
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }
          return new File([u8arr], filename, { type: mime })
        }
        let fileData = dataURLtoFile(img, file)
        // console.log(fileData)

        await s3Upload(urlData.data.data.url[0], fileData)

        const payload = { file_name: urlData.data.data.filename[0] }
        await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)
        const updateData = await UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id)
        // console.log(updateData.data.data.user_info, "updatedata")
        const authUserData = updateData.data.data.user_info
        this.$store.commit("User/setAuthUserProfileImg", authUserData)
        // const authUserData = updateData.data.data[0];
        // this.$store.commit("User/setAuthUserProfile", authUserData);
        // window.location.reload();
        this.$store.commit("Posts/setPercent", true)
      } catch (err) {}
    },

    /**
     * Handle Profile image Upload
     */
    // async handleProfilePicUpload() {
    //   this.isFetchingprofileimage = true
    //   const file = this.$refs.file.files[0]
    //   this.$refs.file.value = ""
    //   try {
    //     const urlPayload = { file_name: [file.name] }
    //     const urlData = await UserRepository.getPresignedUrl(urlPayload)

    //     await s3Upload(urlData.data.data.url[0], file)
    //     const payload = {
    //       file_name: urlData.data.data.filename[0],
    //     }
    //     const updateData = await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)

    //     const authUserData = updateData.data.data[0]
    //     this.$store.commit("User/setAuthUserProfile", authUserData)
    //     window.location.reload()
    //   } catch (err) {}
    // },

    /**
     * Handle Profile image Upload
     */
    // async handleMobileProfilePicUpload() {
    //   this.isFetchingprofileimage = true
    //   const file = this.$refs.mfile.files[0]
    //   this.$refs.mfile.value = ""
    //   try {
    //     const urlPayload = { file_name: [file.name] }
    //     const urlData = await UserRepository.getPresignedUrl(urlPayload)
    //     await s3Upload(urlData.data.data.url[0], file)
    //     const payload = {
    //       file_name: urlData.data.data.filename[0],
    //     }
    //     await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)
    //     const updateData = await UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id)
    //     const authUserData = updateData.data.data.user_info
    //     this.$store.commit("User/setAuthUserProfileImg", authUserData)
    //   } catch (err) {}
    // },

    /**
     * Handle Background image Upload
     */
    // async handleBackgroundPicUpload() {
    //   const file = this.$refs.bg.files[0];
    //   console.log(file.name, " bgimage");

    //   try {
    //     const user = JSON.parse(localStorage.getItem("user"));
    //     const headers = {
    //       Authorization: `Bearer ${user.user.token}`
    //     };
    //     const urlData = await this.$http.post(
    //       `${process.env.BASE_API_URL}/backgroundimage/`,
    //       { image: "people", file_name: file.name },
    //       { headers }
    //     );

    //     // const url = `${process.env.BASE_API_URL}/user/?user_id=${user.user.id}`;

    //     const payload = {
    //       bg_img: urlData.data.data.id
    //     };
    //     // const updateData = await this.$http.put(url, payload, { headers });
    //     const updateData = await UserRepository.updateProfilePic(
    //       payload,
    //       this.authUser.user,
    //       this.currentCircle.id
    //     );
    //     const authUserData = updateData.data.data[0];
    //     console.log(authUserData);
    //     this.$store.commit("User/setAuthUserProfile", authUserData);
    //   } catch (err) {}
    // },

    async handleWBackgroundPicUpload() {
      try {
        const file = this.$refs.Wbg.files[0]
        if (!file.type.includes("image")) {
          this.$notification.error({
            message: "Error",
            description: "Please select only image",
          })
          return
        }
        this.$refs.Wbg.value = ""
        this.handleLoaderBg(true)
        const urlPayload = { file_name: [file.name] }
        const urlData = await UserRepository.getPresignedUrl(urlPayload)
        await s3Upload(urlData.data.data.url[0], file)
        const result = await this.$http.get(`${process.env.BASE_API_URL}/mastertable/?type=image&code=Background&key=User Upload`)
        const res = await this.$http.post(`${process.env.BASE_API_URL}/backgroundimage/`, { file_name: urlData.data.data.filename[0], image_type_id: result.data.data[0].id })
        const payload = { bg_img: res.data.data.id }
        const updateData = await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)
        const res1 = await UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id)
        this.$store.commit("User/setAuthUserProfileBgImg", res1.data.data.user_info)
        this.handleLoaderBg(false)
        this.$notification.success({ message: "Success", description: "Image uploaded Successfully" })
      } catch (err) {
        console.log(err)
        this.$notification.error({ message: "Failed", description: "Background Image not uploaded" })
        this.handleLoaderBg(false)
      }
    },

    async handleMBackgroundPicUpload() {
      try {
        const file = this.$refs.Mbg.files[0]
        if (!file.type.includes("image")) {
          this.$notification.error({
            message: "Error",
            description: "Please select only image",
          })
          return
        }
        this.$refs.Mbg.value = ""
        this.handleLoaderBg(true)
        const urlPayload = { file_name: [file.name] }
        const urlData = await UserRepository.getPresignedUrl(urlPayload)
        await s3Upload(urlData.data.data.url[0], file)
        const result = await this.$http.get(`${process.env.BASE_API_URL}/mastertable/?type=image&code=Background&key=User Upload`)
        const res = await this.$http.post(`${process.env.BASE_API_URL}/backgroundimage/`, { file_name: urlData.data.data.filename[0], image_type_id: result.data.data[0].id })
        const payload = { bg_img: res.data.data.id }
        const updateData = await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)
        const res1 = await UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id)
        this.$store.commit("User/setAuthUserProfileBgImg", res1.data.data.user_info)
        this.handleLoaderBg(false)
        this.$notification.success({ message: "Success", description: "Image uploaded successfully" })
      } catch (err) {
        console.log(err)
        this.$notification.error({ message: "Failed", description: "Background Image not uploaded" })
        this.handleLoaderBg(false)
      }
    },

    // remove background image
    async removebgImage() {
      if (!this.authUser.user.bg_img) {
        return
      }
      const payload = { bg_img: null }
      try {
        this.isBackgroundImageLoading = true
        const updateData = await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)
        const authUserData = updateData.data.data[0]
        this.$store.commit("User/setAuthUserProfile", authUserData)
        this.isBackgroundImageLoading = false
        this.$notification.success({ message: "Success", description: "Image removed successfully" })
      } catch (err) {
        this.$notification.error({ message: "Failed", description: "Background Image not removed" })
        console.log(err)
        this.isBackgroundImageLoading = false
      }
    },

    // remove profile image
    // async removeProfileImage() {
    //   console.log("removeProfileImage()")
    //   this.isFetchingprofileimage = true
    //   const payload = { file_name: null }
    //   try {
    //     await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)
    //     const updateData = await UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id)
    //     const authUserData = updateData.data.data.user_info
    //     this.$store.commit("User/setAuthUserProfileImg", authUserData)
    //     this.$store.commit("Posts/setPercent", true)
    //     this.isFetchingprofileimage = false
    //   } catch (err) {
    //     this.isFetchingprofileimage = false
    //   }
    // },

    // getProfile() {
    //   UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id)
    //     .then(res => {
    //       this.userValues = res.data.data
    //       // console.log(this.userValues.user_info.speciality, this.userValues.user_info.title)
    //       this.recommendations = res.data.data.recommendations
    //       // console.log("I AM CALLING", res.data.data)
    //       this.$store.state.User.user.user["display_name"] = res.data.data.user_info.display_name || "D"
    //       // this.$store.state.User.user.user["display_name"] = res.data.data.user_info.display_name ? res.data.data.user_info.display_name.toLowerCase() : "D"
    //     })
    //     .catch(err => null)
    // },

    handletab(event) {
      this.displayDots2 = false
      this.displayDots2M = false
      this.displayDots2W = false
      switch (event.target.id) {
        case "updates":
          this.selectedTab = "Reviews & More"
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/updates` })
          break
        case "about":
          this.selectedTab = "Reviews & More"
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/about` })
          break
        case "circles":
          this.selectedTab = "Reviews & More"
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/circles/allCircleMembers` })
          break
        case "qa":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/qa` })
          break
        case "polls":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/polls` })
          break
        case "saved":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/saved` })
          break
        case "dovedaily":
          this.selectedTab = "Reviews & More"
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/dovedaily` })
          break
        case "reviews":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/reviews`, params: { ext_ref_id: this.authUser.id, circle_id: this.currentCircle.id } })
          break
        default:
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/updates` })
          break
      }
    },
  },

  // filters: {
  //   humanize: function(value, capitalize = true) {
  //     if (!value) return ""
  //     return capitalize
  //       ? value
  //           .toLowerCase()
  //           .split("_")
  //           .map(e => e.toUpperCase())
  //           .join(" ")
  //       : value
  //           .toLowerCase()
  //           .split("_")
  //           .map(e => e.charAt(0).toUpperCase() + e.substring(1))
  //           .join(" ")
  //   },

  //   total: function(value, ...options) {
  //     if (!value) return ""
  //     return Array.isArray(value) ? `(${value.length})` : ""
  //   },
  // },
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 428px) {
  .m-prof {
    width: 100% !important;
  }
}
.mob {
  @media screen and (max-width: 900px) {
    position: relative;
    top: 100px;
    left: 98%;
    z-index: 9;
  }
}

.option-mob {
  @media screen and (max-width: 900px) {
    width: max-content;
  }
}

.tag-cont {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 17.5px;
  margin-top: 16px;
}

.mag {
  margin-top: 60px;

  @media screen and (max-width: 700px) {
    margin-top: 0px;
  }
}

.mob-tab {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  text-decoration: none;
}

.tabe {
  display: flex;
  gap: 5px;
  align-items: center;
}

li {
  cursor: pointer;
}

.padding-fix {
  margin-top: 10px;
  padding-top: 0px;
}

.review-padding {
  padding-left: 70px;
}

@media screen and (max-width: 426px) {
  .review-padding {
    padding-left: 50px !important;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  .m-prof-sub ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .m-prof-sub {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
  }

  .m-prof {
    box-shadow: none !important;
    background: none !important;
  }

  .m-prof .circle-card-content {
    margin-top: 0rem !important;
  }

  .camera-bttn {
    margin-left: 65px !important;
    margin-top: -50px !important;
  }

  .doc-name {
    text-align: left !important;
    margin-bottom: 1rem !important;
  }

  // .tags {
  //   margin-right: 220px !important;
  // }
  .doc-loc {
    text-align: left !important;
    margin-bottom: 1rem !important;
    word-break: break-all;
  }

  .stars {
    text-align: left !important;
    margin-top: 1rem !important;
  }
}

.spinner-class {
  position: absolute;
  left: 50%;
}

.profile-avatar {
  .menu-content {
    .card-item {
      padding: 10px 14px;
    }
  }
}

.tabs:hover {
  color: #2a71d4;
}

.tags {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  margin-right: 5px;
  border-radius: 4px;
  text-transform: capitalize;
}

.active-tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px !important;
  height: 48px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
}

.tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px !important;
  height: 48px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  // color: #0F1734;
}

.profile-tabs {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  position: absolute;
  margin-left: 17px;
}

.profile-tab {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;

  position: absolute;
  width: 732px;
  height: 48px;
  left: 520px;
  top: 489px;
}

.edit-status-info-container-last {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px;
  gap: 10px;

  width: 238px;
  height: 40px;
}

.profile-edit-header {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #33415f;
}

.profile-edit-header-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px;
  gap: 10px;

  width: 334px;
  height: 40px;
}

.button-text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #2a71d4;
  cursor: pointer;
}

.edit-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 16px;
  gap: 4px;
  // gap: 10px;
  width: 80px;
  height: 32px;
  color: #2a71d4;
  background: #e1eaf7;
  border-radius: 8px;
}

.edit-status-info-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px;
  gap: 10px;

  width: 214px;
  height: 40px;
}

.edit-status-info {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #33415f;
}

.green-tick {
  width: 20px;
  height: 20px;
}

.sub-profile-edit-even {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  background: #f1f5f9;
  width: 334px;
  height: 56px;
}

.sub-profile-edit {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;

  width: 334px;
  height: 56px;
}

.phy-profile-card-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  position: absolute;
  width: 383px;
  height: 937px;
  background: #ffffff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: -100px;
}

.profile-completion-status {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 11px;
  width: 335px;
  height: 60px;
}

.custom-progress .ant-progress-text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 30px;
  text-align: right;
  color: #647490;
}

.custom-progress .ant-progress-bg {
  background-color: #2a71d4;
}

.camera-bttn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  text-align: center;

  i {
    vertical-align: bottom;
    color: #fff !important;
  }

  input {
    opacity: 0;
    width: 100%;
  }
}

.profile-header {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #33415f;
}

.percentage-indicator {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  width: 40px;
  height: 30px;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  color: #647490;
}

.loader-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;

  width: 335px;
  height: 30px;
}

.stat-cont {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 48px;
}

.vertical-seperator {
  width: 1px;
  height: 36px;
  background: #cbd5e1;
}

.num {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #0f1734;
}

.num-text {
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #94a3b8;
}

.circle-on {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 159.01px;
  height: 44px;
}

.circle-mem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 159.01px;
  height: 44px;
}

.statistics {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  padding: 24px 8px;
  width: 335px;
  height: 92px;
  background: #ffffff;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.05);
  border-radius: 8px;

  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.seperator {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 0px;

  width: 335px;
  height: 16px;
}

.location-text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
}

.location-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 335px;
  height: 24px;
}

.username {
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 46px;
  color: #0f1734;
}

.username-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  width: 335px;
  height: 46px;
}

.options {
  width: 6px;
  height: 24px;
  cursor: pointer;
}

.avatar {
  width: 160px;
  height: 160px;
  cursor: pointer;
}

.avatar-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 309px;
  height: 160px;
}

.profile-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 0px;

  width: 315px;
  height: 160px;
}

.profile-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
  width: 335px;
  height: 1120px;
}

.profile-card-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 24px;
  position: absolute;
  width: 383px;
  height: 1168px;
  left: 120px;
  top: 337px;
  background: #ffffff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.banner-image {
  position: absolute;
  width: 1440px;
  height: 400px;
  left: 0px;
  top: 65px;
}

.tag-icon-oran {
  // height: 17.5px;
  // width: 20px;
  color: #f5a623;
  font-size: 12px;
}

.physician-tag {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
  // height: 32px;
  background: #fff0d6;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  color: #f5a623;
}

.divider {
  border: 1px solid #e2e8f0;
}

.info-phy {
  p {
    margin-bottom: 0px;
  }

  .prof-details-title {
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #94a3b8;
  }
}

.banner {
  // min-height: 300px;
  // max-height: 400px;
  height: 400px;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}

.profile-subnav {
  background: #fff;
}

.profile-image {
  min-width: 150px;
  height: 150px;
  align-self: center;
  border-radius: 50%;
}

.doc-info {
  .doc-name {
    font-size: 36px;
    font-weight: 700;
    line-height: 46px;
    white-space: inherit;
  }

  .doc-loc text-truncate,
  .recommendations {
    font-size: 16px;
  }
}

ul.sub-nav {
  list-style-type: none;
  padding: 0;

  li {
    display: inline-block;
    margin-right: 20px;
  }
}

.nav-sec {
  position: relative;
  width: 66%;
  margin-left: 365px;
  text-align: right;

  .sub-nav {
    position: absolute;
    width: 100%;
    bottom: 0;
  }
}

.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  .title {
    font-size: 18px;
    font-weight: bold;
  }

  .sub-title {
    font-size: 16px;
    font-weight: 500;
  }
}

.ad-container {
  background: #b6d28a;
  width: 100%;
  height: 400px;
}
.profile-bg-mob {
  display: none;
  @media screen and (max-width: 700px) {
    z-index: 10;
    display: flex;
  }

  .camera-btn {
    display: none;
    @media screen and (max-width: 700px) {
      display: flex;
      position: absolute;
      bottom: -9%;
      right: 8vw;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.profile-bg {
  @media screen and (max-width: 700px) {
    z-index: 10;
    display: none;
  }

  .camera-btn {
    position: absolute;
    bottom: -9%;
    right: 8vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.rating-box {
  position: absolute;
  left: 50%;
  bottom: -10px;
  transform: translateX(-50%);
  padding: 5px 8px;
  display: flex;
  align-items: center;
  color: #fff;
  border-radius: 15px;

  .star-rating {
    margin-right: 5px;
  }

  span {
    color: #fff;
  }
}

@media screen and (max-width: 581px) {
  .doc-info {
    text-align: center;
    margin-top: 10px;
  }

  .rating-box {
    position: absolute;
    left: 50%;
    bottom: 40%;
    transform: translateX(-50%);
    padding: 5px 8px;
    display: flex;
    align-items: center;
    color: #fff;
    border-radius: 15px;

    .star-rating {
      margin-right: 5px;
    }

    span {
      color: #fff;
    }
  }
}

.full-screen-camera {
  @media screen and (max-width: 800px) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Doctor/DoctorProfile.vue